/*
    PlatformApp item services are maintained manually.
    When an API item is added or removed, keep this file's operation map and service class
    synchronized with ItemServiceFactory.js and its completeness tests.
*/
import { ItemService } from 'spark-core-dx/services'

export const Operations = {
  AIResourceProvisioningOperationItem : {
     ActivateConvokeAIConfiguration: "ActivateConvokeAIConfiguration",
     DiscoverConvokeAIModels: "DiscoverConvokeAIModels",
     PlanConvokeAIResourceProvisioning: "PlanConvokeAIResourceProvisioning",
     ProvisionConvokeAIResource: "ProvisionConvokeAIResource",
     ValidateConvokeAIResource: "ValidateConvokeAIResource",
  },
  AIChatSessionItem : {
     AIExecuteEntityObjectAnalytics: "AIExecuteEntityObjectAnalytics",
     AIExecuteReportAnalytics: "AIExecuteReportAnalytics",
     AIExecuteSourceObjectAnalytics: "AIExecuteSourceObjectAnalytics",
     AIExecuteWarehouseAnalytics: "AIExecuteWarehouseAnalytics",
     AIQuestionClientCommunicationManage: "AIQuestionClientCommunicationManage",
     AIQuestionClientMcpTools: "AIQuestionClientMcpTools",
     AIQuestionEDIDiagnostics: "AIQuestionEDIDiagnostics",
     AIQuestionEntityFieldMapping: "AIQuestionEntityFieldMapping",
     AIQuestionEntityObject: "AIQuestionEntityObject",
     AIQuestionEntityObjectModify: "AIQuestionEntityObjectModify",
     AIQuestionMigration: "AIQuestionMigration",
     AIQuestionReport: "AIQuestionReport",
     AIQuestionSourceObject: "AIQuestionSourceObject",
     AIQuestionSourceObjectManage: "AIQuestionSourceObjectManage",
     AIQuestionThemeManage: "AIQuestionThemeManage",
     AIQuestionClientActivity: "AIQuestionClientActivity",
     AIQuestionClientBilling: "AIQuestionClientBilling",
     AIQuestionWarehouse: "AIQuestionWarehouse",
     AIQuestionWarehouseView: "AIQuestionWarehouseView",
     AIRefreshResult: "AIRefreshResult",
  },
  AIPromptItem : {
     ExecuteAIPrompt: "ExecuteAIPrompt",
  },
  As2MessageItem : {
     AS2MessageReplay: "AS2MessageReplay",
  },
  As2TradingPartnerItem : {
     AS2TradingPartnerCheck: "AS2TradingPartnerCheck",
     AS2TradingPartnerDeploy: "AS2TradingPartnerDeploy",
     AS2TradingPartnerSyncStatus: "AS2TradingPartnerSyncStatus",
  },
  ClientApplicationOptionsItem : {
     SetClientApplicationOptions: "SetClientApplicationOptions",
  },
  ClientAuthenticationWorkspaceItem : {
     DeleteClientEntraMapping: "DeleteClientEntraMapping",
     LoadClientAuthentication: "LoadClientAuthentication",
     RemoveClientAzureMapsOverride: "RemoveClientAzureMapsOverride",
     SaveClientAzureMapsConnection: "SaveClientAzureMapsConnection",
     SaveClientEntraMapping: "SaveClientEntraMapping",
     SaveClientEntraReadConnection: "SaveClientEntraReadConnection",
     TestClientEntraLogin: "TestClientEntraLogin",
     ValidateClientEntraReadConnection: "ValidateClientEntraReadConnection",
  },
  ClientBillingWorkspaceItem : {
     AddClientBillingManualRow: "AddClientBillingManualRow",
     CalculateClientBillingLedger: "CalculateClientBillingLedger",
     LoadClientBilling: "LoadClientBilling",
     LoadClientBillingSources: "LoadClientBillingSources",
     SaveClientBillingConfiguration: "SaveClientBillingConfiguration",
     SetClientBillingControl: "SetClientBillingControl",
  },
  ClientCommandCenterItem : {
     LoadClientCommandCenter: "LoadClientCommandCenter",
     RunClientReadinessChecks: "RunClientReadinessChecks",
  },
  ClientCommandSummaryItem : {
     ShowClientCommandCenter: "ShowClientCommandCenter",
  },
  ClientCommandWorkspaceItem : {
     ExportClientActivitySearch: "ExportClientActivitySearch",
     LoadClientActiveSessions: "LoadClientActiveSessions",
     LoadMarketplacePayments: "LoadMarketplacePayments",
     LoadClientActivityDetail: "LoadClientActivityDetail",
     ResolveClientActivitySourceRecordRoute: "ResolveClientActivitySourceRecordRoute",
     RevokeClientActiveSession: "RevokeClientActiveSession",
     ActivateMarketplacePayment: "ActivateMarketplacePayment",
     DeleteMarketplacePayment: "DeleteMarketplacePayment",
     SearchClientActivity: "SearchClientActivity",
  },
  ClientCommunicationsWorkspaceItem : {
     ClearClientCommunicationOverride: "ClearClientCommunicationOverride",
     DispatchClientInternalNotification: "DispatchClientInternalNotification",
     LoadClientCommunicationOperationStatus: "LoadClientCommunicationOperationStatus",
     LoadClientCommunicationTool: "LoadClientCommunicationTool",
     LoadClientCommunications: "LoadClientCommunications",
     RemoveClientCommunicationToolItem: "RemoveClientCommunicationToolItem",
     SaveClientCommunicationConfiguration: "SaveClientCommunicationConfiguration",
     SaveClientCommunicationToolItem: "SaveClientCommunicationToolItem",
     SaveClientInternalNotificationDraft: "SaveClientInternalNotificationDraft",
     SearchClientNotificationRecipients: "SearchClientNotificationRecipients",
     SelectClientCommunicationProviders: "SelectClientCommunicationProviders",
     TestClientCommunicationProvider: "TestClientCommunicationProvider",
     ValidateClientCommunicationProvider: "ValidateClientCommunicationProvider",
  },
  ClientDatabasePartitionWorkspaceItem : {
     ActivateClientDatabasePartition: "ActivateClientDatabasePartition",
     CompleteClientDatabasePartitionRollback: "CompleteClientDatabasePartitionRollback",
     DeployClientDatabasePartition: "DeployClientDatabasePartition",
     LoadClientDatabasePartitionConfiguration: "LoadClientDatabasePartitionConfiguration",
     LoadClientDatabasePartitionDeploymentInventory: "LoadClientDatabasePartitionDeploymentInventory",
     LoadClientDatabasePartitionStatus: "LoadClientDatabasePartitionStatus",
     PrepareClientDatabasePartition: "PrepareClientDatabasePartition",
     RequestClientDatabasePartitionRollback: "RequestClientDatabasePartitionRollback",
     SaveClientDatabasePartitionRequest: "SaveClientDatabasePartitionRequest",
     SetUpClientDatabasePartitionIdentity: "SetUpClientDatabasePartitionIdentity",
     UpdateClientDatabasePartitionConnection: "UpdateClientDatabasePartitionConnection",
     ValidateClientDatabasePartition: "ValidateClientDatabasePartition",
  },
  ClientDomainsWorkspaceItem : {
     DeployClientDomains: "DeployClientDomains",
     GenerateClientDomains: "GenerateClientDomains",
     LoadClientDomains: "LoadClientDomains",
     ReconcileClientDomainProvisioning: "ReconcileClientDomainProvisioning",
     RemoveClientDomain: "RemoveClientDomain",
     SaveClientDomain: "SaveClientDomain",
  },
  ClientEntraSetupScriptItem : {
     GenerateClientEntraSetupScript: "GenerateClientEntraSetupScript",
  },
  ClientFilesWorkspaceItem : {
     LoadClientFileStorageSummary: "LoadClientFileStorageSummary",
     LoadClientFiles: "LoadClientFiles",
     RemoveClientFile: "RemoveClientFile",
     ResolveClientFileLocation: "ResolveClientFileLocation",
     RevertClientFileStorageToPlatform: "RevertClientFileStorageToPlatform",
     SaveClientFile: "SaveClientFile",
     SearchClientFiles: "SearchClientFiles",
     SetUpClientFileStorage: "SetUpClientFileStorage",
     ValidateClientFileStorage: "ValidateClientFileStorage",
  },
  ClientGuestAccessWorkspaceItem : {
     InviteClientGuest: "InviteClientGuest",
     LoadClientGuestAccess: "LoadClientGuestAccess",
     ReconcileClientGuestAccess: "ReconcileClientGuestAccess",
     ResumeClientGuestReconciliation: "ResumeClientGuestReconciliation",
     RevokeClientGuest: "RevokeClientGuest",
     SaveClientGuestAccessMode: "SaveClientGuestAccessMode",
  },
  ClientInformationItem : {
     LoadClientInformation: "LoadClientInformation",
     SaveClientInformation: "SaveClientInformation",
  },
  ClientOnboardingWizardItem : {
     CancelClientOnboarding: "CancelClientOnboarding",
     ExecuteClientOnboarding: "ExecuteClientOnboarding",
     LoadClientOnboarding: "LoadClientOnboarding",
     LoadClientOnboardingSecurityOptions: "LoadClientOnboardingSecurityOptions",
     ResumeClientOnboarding: "ResumeClientOnboarding",
     RetryClientOnboardingStep: "RetryClientOnboardingStep",
     StartClientOnboarding: "StartClientOnboarding",
     ValidateClientOnboarding: "ValidateClientOnboarding",
  },
  ClientProductOfferItem : {
     AddRuntimeCapacityGrant: "AddRuntimeCapacityGrant",
  },
  ClientResourceItem : {
     AddMarketplaceClientResource: "AddMarketplaceClientResource",
     ApproveClientResource: "ApproveClientResource",
     CancelClientResource: "CancelClientResource",
     LoadClientResourceApprovalQueue: "LoadClientResourceApprovalQueue",
     RejectClientResource: "RejectClientResource",
     SuspendClientResource: "SuspendClientResource",
  },
  ClientRolesPermissionsWorkspaceItem : {
     CloneClientRole: "CloneClientRole",
     CreateClientRoleFromPermissionSet: "CreateClientRoleFromPermissionSet",
     LoadClientRolesPermissions: "LoadClientRolesPermissions",
     SaveClientRoleDetails: "SaveClientRoleDetails",
     SaveClientRoleMappings: "SaveClientRoleMappings",
     SaveClientRolePermission: "SaveClientRolePermission",
     SetClientRoleLifecycle: "SetClientRoleLifecycle",
  },
  ClientThemePairsWorkspaceItem : {
     ActivateThemePair: "ActivateThemePair",
     DeleteClientThemePair: "DeleteClientThemePair",
     LoadClientThemePairs: "LoadClientThemePairs",
     PreviewThemeDraftPair: "PreviewThemeDraftPair",
     SaveClientThemePairDraft: "SaveClientThemePairDraft",
  },
  ClientUserProfilesWorkspaceItem : {
     AssignClientUserRoles: "AssignClientUserRoles",
     LoadClientUserProfiles: "LoadClientUserProfiles",
     RepairClientUserEntraMapping: "RepairClientUserEntraMapping",
     SaveClientUserProfile: "SaveClientUserProfile",
     SearchClientEntraUsers: "SearchClientEntraUsers",
     SetClientUserAccess: "SetClientUserAccess",
  },
  ClientsWorkspaceItem : {
     LoadClientsWorkspace: "LoadClientsWorkspace",
  },
  DashboardItem : {
     LoadDashboardRuntime: "LoadDashboardRuntime",
     MigrateDashboardModelWorkspace: "MigrateDashboardModelWorkspace",
  },
  DataModelItem : {
     CompileDataModelSql: "CompileDataModelSql",
     ValidateDataModelExpression: "ValidateDataModelExpression",
  },
  DataModelWorkspaceItem : {
     BuildDataModelWorkspaceArtifactOnDemand: "BuildDataModelWorkspaceArtifactOnDemand",
     DataModelWorkspaceManage: "DataModelWorkspaceManage",
     DropDataModelsAndData: "DropDataModelsAndData",
     EnsureRemoteBatchHostReady: "EnsureRemoteBatchHostReady",
     GetDataModelsAndDataStatus: "GetDataModelsAndDataStatus",
     LoadDataModelsAndData: "LoadDataModelsAndData",
     PublishDataModelWorkspaceArtifact: "PublishDataModelWorkspaceArtifact",
  },
  DataQueryItem : {
     ExecuteDataModelWorkspaceArtifactQuery: "ExecuteDataModelWorkspaceArtifactQuery",
     ExecuteDataQuery: "ExecuteDataQuery",
     ExportDataQuery: "ExportDataQuery",
  },
  DestinationScheduleItem : {
     ApplyDestinationSchedule: "ApplyDestinationSchedule",
     DispatchDueDestinationSchedules: "DispatchDueDestinationSchedules",
     PreviewDestinationScheduleEvent: "PreviewDestinationScheduleEvent",
     RunDestinationScheduleNow: "RunDestinationScheduleNow",
  },
  EntityMasterRecordItem : {
     FullMasterRecord: "FullMasterRecord",
     LookupMasterEntityObject: "LookupMasterEntityObject",
  },
  EntityObjectItem : {
     AIBuildJSTransform: "AIBuildJSTransform",
     AIEntityFieldMap: "AIEntityFieldMap",
     ClearEntityObjectExternalSchema: "ClearEntityObjectExternalSchema",
     ConvokeQLSearchEntityObject: "ConvokeQLSearchEntityObject",
     EntityObjectFieldMapping: "EntityObjectFieldMapping",
     GenerateEDIDocument: "GenerateEDIDocument",
     GenerateEntityObjectDocumentSchema: "GenerateEntityObjectDocumentSchema",
     LoadEntitiesBySourceObjects: "LoadEntitiesBySourceObjects",
     LoadEntityFields: "LoadEntityFields",
     MapEntityObject: "MapEntityObject",
     ModifyEntity: "ModifyEntity",
     SearchEntityObject: "SearchEntityObject",
     ValidateEDIDocument: "ValidateEDIDocument",
  },
  ExternalSystemItem : {
     ExternalSystemCheck: "ExternalSystemCheck",
     ExternalSystemDiscoverDirty: "ExternalSystemDiscoverDirty",
     ExternalSystemLoadDirtyQueue: "ExternalSystemLoadDirtyQueue",
     ExternalSystemPreview: "ExternalSystemPreview",
     ExternalSystemSync: "ExternalSystemSync",
     ExternalSystemValidate: "ExternalSystemValidate",
  },
  FileStorageItem : {
     FileStorageCheck: "FileStorageCheck",
     FileStorageDeploy: "FileStorageDeploy",
     FileStorageDrop: "FileStorageDrop",
     FileStorageSync: "FileStorageSync",
  },
  IntegrationItem : {
     ConnectionCheck: "ConnectionCheck",
     DropBoxStartOAuth: "DropBoxStartOAuth",
  },
  MigrationProjectItem : {
     AIMigrationAnalyze: "AIMigrationAnalyze",
     AIMigrationApprovePlan: "AIMigrationApprovePlan",
     AIMigrationGenerateMappingDraft: "AIMigrationGenerateMappingDraft",
     AIMigrationRunAnalysis: "AIMigrationRunAnalysis",
     OpenMigrationMappingDraft: "OpenMigrationMappingDraft",
     OpenMigrationProjectAdvisor: "OpenMigrationProjectAdvisor",
  },
  ProductMarketplaceCatalogItem : {
     LoadProductMarketplaceCatalog: "LoadProductMarketplaceCatalog",
     SubmitMarketplacePaymentSupportRequest: "SubmitMarketplacePaymentSupportRequest",
  },
  ProductMarketplaceValidationReportItem : {
     ValidateProductMarketplaceDefinitions: "ValidateProductMarketplaceDefinitions",
     ValidateProductResourceSetupPaths: "ValidateProductResourceSetupPaths",
  },
  ProductResourceDefinitionItem : {
     PromoteProductResourceMaturity: "PromoteProductResourceMaturity",
  },
  ProductResourceSetupPathDefinitionsItem : {
     LoadProductResourceSetupPathDefinitions: "LoadProductResourceSetupPathDefinitions",
  },
  ProductResourceSetupPathResultItem : {
     LoadProductResourceSetupPath: "LoadProductResourceSetupPath",
  },
  RemoteBatchHostItem : {
     CheckRemoteBatchHostStatus: "CheckRemoteBatchHostStatus",
     DrainRemoteBatchHost: "DrainRemoteBatchHost",
     RestartRemoteBatchHost: "RestartRemoteBatchHost",
     RunRemoteBatchHostManualTest: "RunRemoteBatchHostManualTest",
     StartRemoteBatchHost: "StartRemoteBatchHost",
     StopRemoteBatchHost: "StopRemoteBatchHost",
  },
  ResourceConfigurationItem : {
     ResourceActivationOperation: "ResourceActivationOperation",
     ResourceDeactivationOperation: "ResourceDeactivationOperation",
     CreateClientMcpServerPersonalAccessToken: "CreateClientMcpServerPersonalAccessToken",
     DeleteResourceConfiguration: "DeleteResourceConfiguration",
     DownloadClientMcpServerOAuthSetupScript: "DownloadClientMcpServerOAuthSetupScript",
     GenerateInboundEdiSourceObjects: "GenerateInboundEdiSourceObjects",
     ImportEntitySchemaResourceConfiguration: "ImportEntitySchemaResourceConfiguration",
     LoadClientMcpServerActiveSessions: "LoadClientMcpServerActiveSessions",
     LoadResourceConfigurationManagementSummary: "LoadResourceConfigurationManagementSummary",
     ReconfigureResourceConfiguration: "ReconfigureResourceConfiguration",
     RetireResourceConfiguration: "RetireResourceConfiguration",
     RevokeClientMcpServerActiveSession: "RevokeClientMcpServerActiveSession",
     RevokeClientMcpServerPersonalAccessToken: "RevokeClientMcpServerPersonalAccessToken",
     RunInboundEdiTestParseValidation: "RunInboundEdiTestParseValidation",
     SaveClientMcpServerSettings: "SaveClientMcpServerSettings",
     SaveClientMcpToolsAuthorization: "SaveClientMcpToolsAuthorization",
     SaveInboundEdiOperationalProfile: "SaveInboundEdiOperationalProfile",
     SetupClientMcpToolsResource: "SetupClientMcpToolsResource",
     SetupPrivilegedMcpToolsResources: "SetupPrivilegedMcpToolsResources",
     TestClientMcpServerCurrentUserConnection: "TestClientMcpServerCurrentUserConnection",
     UpdateResourceConfigurationDetails: "UpdateResourceConfigurationDetails",
     UpdateResourceConfigurationLinkedRecord: "UpdateResourceConfigurationLinkedRecord",
     ValidateInboundEdiConnection: "ValidateInboundEdiConnection",
     ValidateResourceConfigurationReadiness: "ValidateResourceConfigurationReadiness",
  },
  ResourceConfigurationReviewSummaryItem : {
     LoadResourceConfigurationReviewSummary: "LoadResourceConfigurationReviewSummary",
  },
  ResourceConfigurationWizardItem : {
     CancelResourceConfigurationSetup: "CancelResourceConfigurationSetup",
     CompleteResourceConfiguration: "CompleteResourceConfiguration",
     CompleteResourceConfigurationStep: "CompleteResourceConfigurationStep",
     EditResourceConfigurationStep: "EditResourceConfigurationStep",
     LoadResourceConfigurationWizard: "LoadResourceConfigurationWizard",
     ResourceConfigurationWizardValidate: "ResourceConfigurationWizardValidate",
     ResourceStepCleanup: "ResourceStepCleanup",
     SaveResourceConfigurationStep: "SaveResourceConfigurationStep",
     StartOrResumeResourceConfiguration: "StartOrResumeResourceConfiguration",
     StubResourcePurchaseReview: "StubResourcePurchaseReview",
  },
  ResourceUsageEstimateItem : {
     CalculateResourceUsageEstimate: "CalculateResourceUsageEstimate",
  },
  SchemaItem : {
     CreateEDISchema: "CreateEDISchema",
     CreateEntitySchemaFromDestinationSchema: "CreateEntitySchemaFromDestinationSchema",
     CreateEntitySchemaFromSource: "CreateEntitySchemaFromSource",
     CreateSchema: "CreateSchema",
     ImportEntityObjectFromExternalSchema: "ImportEntityObjectFromExternalSchema",
  },
  SchemaAPIItem : {
     SaveResourceConfigurationLinkedEndpoint: "SaveResourceConfigurationLinkedEndpoint",
  },
  SourceObjectItem : {
     AISourceColumnSet: "AISourceColumnSet",
     GenerateSourceObjectDocumentSchema: "GenerateSourceObjectDocumentSchema",
     LoadEDIDiagnosticsContext: "LoadEDIDiagnosticsContext",
     LoadSourceObjectKeys: "LoadSourceObjectKeys",
     ManageSourceObject: "ManageSourceObject",
     SearchSourceObject: "SearchSourceObject",
     SetSourceObjectUniqueFields: "SetSourceObjectUniqueFields",
     ValidateSourceObjectKeys: "ValidateSourceObjectKeys",
  },
  SourceSystemItem : {
     ClearSourceObjectExternalSchema: "ClearSourceObjectExternalSchema",
     ImportSourceObjectFromExternalSchema: "ImportSourceObjectFromExternalSchema",
     LoadSourceObjects: "LoadSourceObjects",
     LoadSourceSystemTargets: "LoadSourceSystemTargets",
  },
  VisualItem : {
     LoadVisualOptions: "LoadVisualOptions",
  },
  WarehouseItem : {
     CloneWarehouseDeployment: "CloneWarehouseDeployment",
     FullWarehouseLoadProcess: "FullWarehouseLoadProcess",
     OpenWarehouseViewDesigner: "OpenWarehouseViewDesigner",
     SearchWarehouseObject: "SearchWarehouseObject",
     WarehouseCheck: "WarehouseCheck",
     WarehouseDeploy: "WarehouseDeploy",
     WarehouseDrop: "WarehouseDrop",
     WarehouseUpgrade: "WarehouseUpgrade",
  },
  WarehouseViewItem : {
     DeployWarehouseView: "DeployWarehouseView",
     DeployWarehouseViews: "DeployWarehouseViews",
     DiscoverWarehouseDatabaseViews: "DiscoverWarehouseDatabaseViews",
     ListWarehouseViews: "ListWarehouseViews",
     RefreshWarehouseViewFields: "RefreshWarehouseViewFields",
     SaveWarehouseView: "SaveWarehouseView",
     SearchWarehouseView: "SearchWarehouseView",
     ValidateWarehouseView: "ValidateWarehouseView",
  },
}

export class AIAnalyticsItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIAnalytics", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIAvailabilityPolicyItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIAvailabilityPolicy", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIModelCatalogItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIModelCatalog", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIModelPackageItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIModelPackage", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIProviderDeploymentItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIProviderDeployment", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIProviderProfileItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIProviderProfile", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIProviderStateConformanceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIProviderStateConformance", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIResourceProvisioningOperationItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIResourceProvisioningOperation", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AISharedFoundryShardItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AISharedFoundryShard", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIChatItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIChat", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIChatSessionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIChatSession", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIChatStepItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIChatStep", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AILevelProfileItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AILevelProfile", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class AIPromptItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/AIPrompt", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class As2MessageItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/As2Message", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class As2TradingPartnerItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/As2TradingPartner", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class BatchManagementPreferenceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/BatchManagementPreference", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ClientApplicationOptionsItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientApplicationOptions", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientAuthenticationWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientAuthenticationWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientAzureMapsConnectionFormItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientAzureMapsConnectionForm", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientBillingControlRequestItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientBillingControlRequest", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientBillingLedgerItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientBillingLedger", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ClientBillingManualRowRequestItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientBillingManualRowRequest", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientBillingProfileItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientBillingProfile", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ClientBillingWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientBillingWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommandCapabilityItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommandCapability", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommandCenterItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommandCenter", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommandOperationResultItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommandOperationResult", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommandScopeItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommandScope", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommandSummaryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommandSummary", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommandWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommandWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommunicationConfigurationItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommunicationConfiguration", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommunicationProviderActionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommunicationProviderAction", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientCommunicationsWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientCommunicationsWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientDatabasePartitionWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientDatabasePartitionWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientDomainCommandItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientDomainCommand", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientDomainGenerationRequestItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientDomainGenerationRequest", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientDomainsWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientDomainsWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientEntraConnectionFormItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientEntraConnectionForm", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientEntraMappingFormItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientEntraMappingForm", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientEntraSetupScriptItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientEntraSetupScript", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientFileCommandItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientFileCommand", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientFileStorageSetupItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientFileStorageSetup", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientFilesWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientFilesWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientGuestAccessWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientGuestAccessWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientInformationItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientInformation", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientOnboardingRunItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientOnboardingRun", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientOnboardingWizardItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientOnboardingWizard", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientProductOfferItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientProductOffer", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ClientResourceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientResource", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ClientResourceActivityItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientResourceActivity", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ClientRoleFormItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientRoleForm", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientRoleMappingFormItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientRoleMappingForm", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientRolePermissionFormItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientRolePermissionForm", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientRolesPermissionsWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientRolesPermissionsWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientThemePairItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientThemePair", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientThemePairsWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientThemePairsWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientUserProfileFormItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientUserProfileForm", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientUserProfilesWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientUserProfilesWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ClientsWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ClientsWorkspace", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ConvokeAppConfigItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ConvokeAppConfig", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DashboardItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Dashboard", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataModelItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataModel", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataModelWorkspaceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataModelWorkspace", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataModelWorkspaceArtifactVersionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataModelWorkspaceArtifactVersion", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataModelWorkspaceBuildRunItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataModelWorkspaceBuildRun", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataQueryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataQuery", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DataTypeItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DataType", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DestinationScheduleItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DestinationSchedule", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class DirtyRecordDeploymentItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/DirtyRecordDeployment", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EdiPartnerScopePolicyItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EdiPartnerScopePolicy", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EdiTradingPartnerItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EdiTradingPartner", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EdiTradingPartnerGroupItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EdiTradingPartnerGroup", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EdiTradingPartnerGroupMemberItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EdiTradingPartnerGroupMember", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EdiUsageLedgerItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EdiUsageLedger", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityMasterRecordItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityMasterRecord", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityMasterRecordMapItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityMasterRecordMap", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityObjectItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityObject", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityObjectFieldMapItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityObjectFieldMap", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityObjectLoopMapItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityObjectLoopMap", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class EntityQueryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/EntityQuery", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ExternalAppItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalApp", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ExternalAppSettingItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalAppSetting", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class ExternalSystemItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalSystem", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ExternalSystemDirtyRecordItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalSystemDirtyRecord", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ExternalSystemDirtyScanStateItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ExternalSystemDirtyScanState", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class FeatureItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Feature", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class FileStorageItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/FileStorage", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class FormConditionalItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/FormConditional", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class IntegrationItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Integration", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class IntegrationSetupGuideItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/IntegrationSetupGuide", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class MigrationMappingDraftItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/MigrationMappingDraft", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class MigrationProjectItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/MigrationProject", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ModuleDefinitionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ModuleDefinition", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ModulePermissionBaselineItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ModulePermissionBaseline", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class PricingEstimateSnapshotItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/PricingEstimateSnapshot", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductDefinitionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductDefinition", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceAllowanceDefaultItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceAllowanceDefault", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceCatalogItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceCatalog", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceExposureDefaultItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceExposureDefault", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplacePermissionSetEntryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplacePermissionSetEntry", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplacePricingEstimateDefaultItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplacePricingEstimateDefault", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceSetupBindingItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceSetupBinding", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceSetupFieldDefinitionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceSetupFieldDefinition", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceSetupOperationBindingItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceSetupOperationBinding", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceSetupPathDefinitionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceSetupPathDefinition", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceSetupSectionStepDefinitionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceSetupSectionStepDefinition", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceSetupStepDefinitionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceSetupStepDefinition", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceUsagePricingDefaultItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceUsagePricingDefault", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductMarketplaceValidationReportItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductMarketplaceValidationReport", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductOfferCapacityGrantItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductOfferCapacityGrant", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductOfferDefinitionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductOfferDefinition", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductOfferPlacementItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductOfferPlacement", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductOfferPriceSnapshotItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductOfferPriceSnapshot", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductOfferResourceGrantItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductOfferResourceGrant", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductResourceDefinitionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductResourceDefinition", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductResourceSetupPathDefinitionsItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductResourceSetupPathDefinitions", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ProductResourceSetupPathResultItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ProductResourceSetupPathResult", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class RemoteBatchHostItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/RemoteBatchHost", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceAllowanceItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceAllowance", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfiguration", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationLinkedRecordItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationLinkedRecord", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationManagementSummaryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationManagementSummary", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationReadinessSnapshotItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationReadinessSnapshot", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationReviewSummaryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationReviewSummary", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationReviewSummaryFactItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationReviewSummaryFact", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationReviewSummaryRecordItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationReviewSummaryRecord", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationReviewSummarySectionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationReviewSummarySection", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationSetupRunItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationSetupRun", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationSetupRunSectionStepItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationSetupRunSectionStep", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationSetupRunStepItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationSetupRunStep", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationValidationIssueItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationValidationIssue", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceConfigurationWizardItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceConfigurationWizard", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceUsageEstimateItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceUsageEstimate", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceUsageEstimateLineItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceUsageEstimateLine", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class ResourceUsageEstimateSnapshotItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/ResourceUsageEstimateSnapshot", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class RuntimeCapacityLeaseItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/RuntimeCapacityLease", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SageCustomerItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SageCustomer", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class SageVendorItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SageVendor", coreState, coreContext, "PLATFORMAPP", null, isWarning);
    }

}

export class SchemaItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Schema", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SchemaAPIItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SchemaAPI", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SchemaAPIMcpOAuthClientItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SchemaAPIMcpOAuthClient", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SchemaDestinationLogItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SchemaDestinationLog", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SourceObjectItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SourceObject", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SourceObjectRecordItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SourceObjectRecord", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SourceQueryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SourceQuery", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class SourceSystemItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/SourceSystem", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class TransformScriptItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/TransformScript", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class UserDashboardWorkspaceStateItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/UserDashboardWorkspaceState", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class VisualItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Visual", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class VisualColorPaletteOptionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/VisualColorPaletteOption", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class VisualRenderOptionItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/VisualRenderOption", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class VisualTypeItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/VisualType", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class WarehouseItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/Warehouse", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class WarehouseViewItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/WarehouseView", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class WarehouseViewFieldItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/WarehouseViewField", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}

export class WarehouseViewQueryItemService extends ItemService {

    constructor(coreState, coreContext, isWarning) {
        super("Items/WarehouseViewQuery", coreState, coreContext, "CONVOKE", null, isWarning);
    }

}
